module.exports = __webpack_public_path__ + "static/ufo_about2-fc7cedb1c7d9323e807bbd32b2f4d2f8.png";